export const API_BASE_URL = process.env.REACT_APP_MIDDLEWARE_API_BASE_URL;
export const ROUTES = {
  getDropdownValues: `${API_BASE_URL}/getDropdownValues`,
  getEmpDetailsByEmail: `${API_BASE_URL}/getEmpDetails`,
  getEmpOracleDetails: `${API_BASE_URL}/getEmpOracleDetails`,
  addCareerCard: `${API_BASE_URL}/addEmpDetails`,
  addCareerCardOtherDetails: `${API_BASE_URL}/addEmpOtherDetails`,
  getEmpOracleHierarchyDetails: `${API_BASE_URL}/getHierarchyDetails`,
  importFromExcel: `${API_BASE_URL}/importUserDataFromExcel`,
  AUTH_PINGAUTHURL : `${API_BASE_URL}/auth/ping_auth_url`,
  AUTH_PINGTOKEN : `${API_BASE_URL}/callback`,
  AUTH_REFRESH_TOKEN : `${API_BASE_URL}/auth/refresh_token`,
  // OrgChart PostgreSQL endpoints
  getOrgChartEmployee: `${API_BASE_URL}/getOrgChartEmployee`,
  getOrgChartDirects: `${API_BASE_URL}/getOrgChartDirects`,
};